/**
 * Static SVG lookup tables for primary-rail module icons. The JSX helper
 * functions that consume these tables live in SidebarRail.icons.tsx.
 */

/** Icon key → SVG, for config.icon overrides and archetype label fallbacks. */
export const ICON_BY_KEY: Record<string, React.ReactNode> = (() => {
  const c = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };
  return {
    // Scratch — free-form notes / scratchpad
    notebook: <svg {...c}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
    // Chapter Work — open book / manuscript
    book: <svg {...c}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>,
    // Roadmap — map with fold lines
    map: <svg {...c}><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" /><line x1="9" y1="3" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="21" /></svg>,
    // Readers & Experts — people/contacts (same as contact_list)
    users: <svg {...c}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
    // Writer's Studio Guide — lightbulb/ideas
    lightbulb: <svg {...c}><path d="M9 21h6" /><path d="M12 3a6 6 0 0 1 6 6c0 2.22-1.2 4.16-3 5.2V17a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2.8C7.2 13.16 6 11.22 6 9a6 6 0 0 1 6-6z" /></svg>,
    // Book Status — bar chart / progress
    'bar-chart': <svg {...c}><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>,
  };
})();

/** Icon lookup priority: config.icon key → archetype label → module type. */
export const ARCHETYPE_LABEL_ICONS: Record<string, React.ReactNode> = {
  'Scratch': ICON_BY_KEY['notebook'],
  'Chapter Work': ICON_BY_KEY['book'],
  'Roadmap': ICON_BY_KEY['map'],
  'Readers & Experts': ICON_BY_KEY['users'],
  "Writer's Studio Guide": ICON_BY_KEY['lightbulb'],
  'Book Status': ICON_BY_KEY['bar-chart'],
};
